function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1243.401 -415.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1243.401 415.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1287.807,464.5h-39.813a4.6,4.6,0,0,1-4.594-4.594V420.094a4.6,4.6,0,0,1,4.594-4.594h39.813a4.6,4.6,0,0,1,4.594,4.594v39.813A4.6,4.6,0,0,1,1287.807,464.5Zm-39.813-45.937a1.533,1.533,0,0,0-1.531,1.531v39.813a1.533,1.533,0,0,0,1.531,1.531h39.813a1.532,1.532,0,0,0,1.531-1.531V420.094a1.532,1.532,0,0,0-1.531-1.531Z",
  transform: "translate(-1243.401 -415.5)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1254.12 438.469)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27.563,
  height: 3.063
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1258.714 427.75)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18.375,
  height: 3.063
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1258.714 449.188)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18.375,
  height: 3.063
})));

var SvgSingle = function SvgSingle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSingle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/single.68046b89.svg";
export { ForwardRef as ReactComponent };